import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";

const SearchInput = ({
  textColor,
  className = "",
  label,
  info,
  id,
  name,
  type = "text",
  value,
  onChange,
  placeholder,
}) => {
  const handleChange = async (e) => {
    onChange && (await onChange(e));
  };

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={id || name}
          className={`block text-sm font-bold text-${textColor ? `${textColor}-500` : "gray-700"} mb-2`}
        >
          {label}
        </label>
      )}
      {info && (
        <p className="block tracking-wide text-gray-400 text-xs text-left mb-2">
          {info}
        </p>
      )}
      <div className="w-full relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-4.35-4.35m0 0a7 7 0 11-9.9-9.9 7 7 0 019.9 9.9z"
            />
          </svg>
        </span>
        <input
          id={id || name}
          name={name}
          type={type}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          className={`pl-10 text-sm appearance-none focus:outline-none block w-full placeholder-gray-400 border rounded-lg py-3 px-4 leading-tight border-gray-200 focus:border-primary-500"
          hover:border-gray-400 ${textColor ? `focus:border-${textColor}-500` : "focus:border-primary-500"} data-hj-allow bg-white text-gray-700 ${className}`}
        />
      </div>
    </div>
  );
};

SearchInput.displayName = "SearchInput";

export const searchInputControls = {
  name: {
    propType: PropTypes.string.isRequired,
    description: "Input name",
    controlType: "text",
  },
  label: {
    propType: PropTypes.string.isRequired,
    description: "Input label",
    controlType: "text",
  },
  info: {
    propType: PropTypes.string,
    description: "Input description",
    controlType: "text",
  },
  textColor: {
    propType: PropTypes.string,
    description: "Input description",
    controlType: "select",
    options: ["primary", "orange", "purple", null],
  },
};

SearchInput.propTypes = AppUtils.getPropTypeFromControls(searchInputControls);

export default SearchInput;
